import { render, staticRenderFns } from "./baseHeader.vue?vue&type=template&id=654b63a6"
import script from "./baseHeader.vue?vue&type=script&lang=js"
export * from "./baseHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports